var ASSET_CONTAINER_ID = 'mf-ui-assets';
export var getAssetContainer = function () {
  return document.getElementById(ASSET_CONTAINER_ID);
};
export var assetLoaded = function (src) {
  return document.getElementById(src);
};
var SpriteSheetLoader = /** @class */function () {
  function SpriteSheetLoader() {
    if (!getAssetContainer()) {
      this.createAssetContainer();
    }
  }
  SpriteSheetLoader.prototype.createAssetContainer = function () {
    var element = document.createElement('DIV');
    element.setAttribute('id', ASSET_CONTAINER_ID);
    element.setAttribute('style', 'position:absolute;height:0;visibility: hidden;overflow: hidden;');
    document.body.appendChild(element);
  };
  SpriteSheetLoader.prototype.load = function (src) {
    if (!assetLoaded(src)) {
      this.loadAsset(src).then(function (rawResponse) {
        return rawResponse.text();
      }).then(function (svgCode) {
        var wrapper = document.createElement('div');
        wrapper.setAttribute('id', src);
        wrapper.innerHTML = svgCode.replace(new RegExp('script', 'g'), 'scrpt');
        var container = getAssetContainer();
        if (container !== null && wrapper.firstChild !== null) {
          container.appendChild(wrapper.firstChild);
        }
      });
    }
  };
  SpriteSheetLoader.prototype.loadAsset = function (src) {
    return fetch(src);
  };
  return SpriteSheetLoader;
}();
export { SpriteSheetLoader };